import { useState } from "react";

/**
 * Keeps a callout's controls non-interactive while its entrance animation runs.
 *
 * The reveal slides + grows the pill into place (FnrFade / motion). If the
 * cursor already sits where a control lands — e.g. the undo/dismiss button
 * appearing under the pointer right after a Save — the moving box passes through
 * the cursor and flicks `:hover` on, off, then on again, so the button's fill
 * stutters (the "hover flickers the first time after it mounts" bug). Gating
 * `pointer-events` to the settled state removes the flicker: the control isn't a
 * hit-test target while it's in motion, and once settled the cursor's hover
 * engages cleanly. Hovering an already-settled callout was never affected.
 *
 * Wire `setAnimating` to the entrance: FnrFade's `setIsAnimating`, or motion's
 * `onAnimationStart`/`onAnimationComplete`. Default `interactive` is true so a
 * callout that never animates (or a test env) stays clickable.
 */
export function useEntranceSettled() {
  const [animating, setAnimating] = useState(false);
  return { interactive: !animating, setAnimating };
}
